import React from 'react';
import { Helmet } from 'react-helmet-async';

import { Box } from '@mui/material';

export interface PageProps {
  title?: string;
  children?: React.ReactNode;
  ref?: React.RefObject<HTMLDivElement>;
}

export default function Page({ title, children, ref, ...other }: PageProps) {
  return (
    <Box ref={ref} {...other}>
      <Helmet>
        <title>{title || 'Center Norte ADM'}</title>
      </Helmet>
      {children}
    </Box>
  );
}
